export const SHOWLOADING = 'SHOWLOADING'
export const HIDELOADING  = 'HIDELOADING'
export const GET_USER_INFO = 'GET_USER_INFO'




// WEBPACK FOOTER //
// ./src/store/mutationType.js